import { forwardRef } from 'react';
import usePriceCurrency from './usePriceCurrency';

const withPriceCurrency = (Component) => {
  const WithPriceCurrency = forwardRef((props, ref) => {
    const value = usePriceCurrency();

    return (
      <Component
        {...props}
        {...value}
        ref={ref}
      />
    );
  });

  WithPriceCurrency.displayeName = Component.displayeName;

  return WithPriceCurrency;
};

export default withPriceCurrency;
